import React from 'react'
import { Typography, Box } from '@material-ui/core'
import { useHistory } from 'react-router-dom'

const cardStyle = {
  backgroundColor: '#fff',
  borderRadius: 8,
  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
  padding: 16
}

const itemStyle = {
  padding: '6px 0',
  fontSize: 13,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'flex-start',
  gap: 8
}

const ActionItems = ({ projectId, summary, bySection, vendorQuoteSummary }) => {
  const history = useHistory()
  const items = []

  // Missing items
  const missingItems = summary?.missingItems || 0
  if (missingItems > 0) {
    items.push({
      icon: '\u26A0',
      text: `${missingItems} item${missingItems !== 1 ? 's' : ''} need pricing`,
      color: '#e65100',
      onClick: () => history.push(`/bid-estimation/${projectId}/items?coverageStatus=missing`)
    })
  }

  // Pending vendor quotes (unimported)
  const pending = vendorQuoteSummary?.pendingQuotes || []
  for (const q of pending) {
    items.push({
      icon: '\u2610',
      text: `Review ${q.vendor || 'vendor'} quote${q.lineItemCount ? ` (${q.lineItemCount} items)` : ''}`,
      color: '#333',
      onClick: () => history.push(`/bid-estimation/${projectId}/vendor-quotes`)
    })
  }

  // Expired vendor quotes
  const expired = vendorQuoteSummary?.expiredQuotes || []
  for (const q of expired) {
    const expDate = q.expirationDate ? new Date(q.expirationDate).toLocaleDateString() : ''
    items.push({
      icon: '\u26A0',
      text: `${q.vendor || 'Vendor'} quote expired ${expDate}`,
      color: '#e65100',
      onClick: () => history.push(`/bid-estimation/${projectId}/vendor-quotes`)
    })
  }

  // Low coverage sections
  if (bySection) {
    Object.entries(bySection).forEach(([section, data]) => {
      if (data.items > 0 && data.covered < data.items) {
        const pct = Math.round((data.covered / data.items) * 100)
        if (pct < 80) {
          items.push({
            icon: '\u2610',
            text: `${section} is ${pct}% covered`,
            color: '#333',
            onClick: () => history.push(`/bid-estimation/${projectId}/items`)
          })
        }
      }
    })
  }

  // If all covered
  if (items.length === 0 && summary?.totalItems > 0) {
    items.push({
      icon: '\u2713',
      text: 'All items have pricing',
      color: '#2e7d32',
      onClick: null
    })
  }

  return (
    <div style={cardStyle}>
      <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 8 }}>
        Action Items
      </Typography>
      {items.length === 0 ? (
        <Typography variant="body2" color="textSecondary">No data yet.</Typography>
      ) : (
        items.map((item, idx) => (
          <Box
            key={idx}
            style={{ ...itemStyle, color: item.color }}
            onClick={item.onClick}
          >
            <span style={{ flexShrink: 0 }}>{item.icon}</span>
            <span>{item.text}</span>
          </Box>
        ))
      )}
    </div>
  )
}

export default ActionItems
